/// <reference path="~/js/viz/shared/models/SelectorsModel.js"/>

(function($, _) {
  var ns = window.nspace("ccc.viz.shared.views");

  /**
   * A friendly no data message view that appears if a user unselects all checkboxes.
   */
  ns.NoDataView = Backbone.View.extend({
    initialize: function(options) {
      _.bindAll(this);

      this.validateView();

      this.initialRenderPromise = $.Deferred();

      this.selectorsModel = options.selectorsModel;

      this.model.on("change", this.render);
    },

    validateView: function() {
      if (!this.el) {
        throw "Subviews need to implement the el property.";
      }
      if (!this.name) {
        throw "Subviews need to implement the name property.";
      }
      if (!this.templateSelector) {
        throw "Subviews need to implement the templateSelector property.";
      }
    },

    getInitialRenderPromise: function() {
      return this.initialRenderPromise;
    },

    loadTemplate: function() {
      // Get the underscore template
      if (!this.template) {
        var $tmpl = $(this.templateSelector);
        if ($tmpl.length === 0) {
          throw "Could not find the " +
            this.name +
            " template: " +
            this.templateSelector;
        }

        // Pre-compile and cache the template
        this.template = _.template($tmpl.html());
      }
    },

    render: function() {
      var self;

      self = this;
      if (self.selectorsModel.areModelArraysValid()) {
        return;
      }

      // Verify this selector's container is present
      if (self.$el.length === 0) {
        throw "Could not find the " + self.name + " container: " + self.el;
      }

      // Load the template
      self.loadTemplate();

      // Render the output
      self.$el.html(self.template());

      // Animate the transition
      self.$el.hide().fadeIn(function() {
        self.initialRenderPromise.resolve();
      });
    }
  });
})(jQuery, _);
